// The choices in the "Flyt linje/segment/del i Z" dialog, as the plain data its host dialog (kind 'offset', see HostDialog.js) renders.
// A choice is converted to the cm it moves the line by here, so the host only ever works in cm:
//   Standard    - the value is a distance in cm
//   Vand        - the value is a dimension in mm; the line moves the whole dimension
//   Spildevand  - as Vand, and the host counts the wall thickness (tab.wall) with its own sign on the signed offset: down with + goes from
//                 the outer top of the pipe to its inner bottom (-20 + 4 = -16 cm)
//   Fjernvarme  - from the top of the casing to the centerline of the pipe: half the casing diameter (DISTRICT_HEATING_PIPES)
import {t} from "./i18n/index.js";

const STANDARD_CM = [1, 2, 3, 5, 10, 15, 20, 25, 30, 40, 50, 75, 100, 150];
const WATER_MM = [20, 25, 32, 40, 50, 63, 75, 90, 110, 125, 140, 160, 180, 200];
const SEWER_MM = [75, 90, 110, 125, 160, 200, 250, 300, 315, 400, 450, 500, 600, 630];
// Pre-insulated steel district heating pipes, single pipe, series 1. Diameters in mm: the steel service pipe and the outer casing.
const DISTRICT_HEATING_PIPES = [
	{dn: 20, serviceMm: 26.9, casingMm: 90},
	{dn: 25, serviceMm: 33.7, casingMm: 90},
	{dn: 32, serviceMm: 42.4, casingMm: 110},
	{dn: 40, serviceMm: 48.3, casingMm: 110},
	{dn: 50, serviceMm: 60.3, casingMm: 125},
	{dn: 65, serviceMm: 76.1, casingMm: 140},
	{dn: 80, serviceMm: 88.9, casingMm: 160},
	{dn: 100, serviceMm: 114.3, casingMm: 200},
	{dn: 125, serviceMm: 139.7, casingMm: 225},
	{dn: 150, serviceMm: 168.3, casingMm: 250},
	{dn: 200, serviceMm: 219.1, casingMm: 315},
	{dn: 250, serviceMm: 273.0, casingMm: 400},
	{dn: 300, serviceMm: 323.9, casingMm: 450},
	{dn: 350, serviceMm: 355.6, casingMm: 500},
];

const cmPresets = (values) => values.map((value) => ({label: String(value), valueCm: value}));
const mmPresets = (values) => values.map((value) => ({label: String(value), valueCm: value / 10}));
const districtHeatingPresets = () => DISTRICT_HEATING_PIPES.map(({dn, casingMm}) => ({
	label: String(dn),
	valueCm: casingMm / 20,
	info: t("DN{0} · Kappe Ø{1} mm · Top til centerlinje", dn, casingMm),
}));

export function buildMoveZTabs(){
	return [
		{id: "standard", label: t("Standard"), presetLabel: t("Afstand · cm"), presets: cmPresets(STANDARD_CM)},
		{id: "water", label: t("Vand"), presetLabel: t("Dimension · mm"), presets: mmPresets(WATER_MM)},
		{
			id: "sewer",
			label: t("Spildevand"),
			presetLabel: t("Dimension · mm (handelsmål)"),
			presets: mmPresets(SEWER_MM),
			wall: {label: t("Godstykkelse (mm)"), minusLabel: t("Træk godstykkelsen fra forskydningen"), plusLabel: t("Læg godstykkelsen til forskydningen")},
		},
		{id: "districtHeating", label: t("Fjernvarme"), presetLabel: t("Dimension · DN"), presets: districtHeatingPresets()},
	];
}
